import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const OcurrencesByHour = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Ocorrências por período (Horas do dia)'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByHour?.map((item) => item.description)}
            values={chartData?.ocurrencesByHour?.map((item) => item.total || 0)}
        />
    );
};